import { useMobile } from 'src/hooks/useMobile'
import { InView } from 'react-intersection-observer'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'
import { getFeatureObject } from 'src/utils/amplitude/getFeatureObject'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'

import InfoBannerItem from './InfoBannerItem'
import InfoBannerCarrosel from './InfoBannerCarrosel'

import './styles.scss'

export interface CarroselDataCMS {
  carroselConfig: {
    backgroundColorImage: string
    backgroundColorText: string
    fontColorDescription: string
    fontColorTitle: string
    backgroundFullImage: boolean
    link: string
  }
  carroselContent: {
    enable: boolean
    enableText: boolean
    enableImage: boolean
    title: string
    description: string
    imageMobile: string
    imageTablet: string
    imageDesktop: string
  }
}

export default function InfoBanner({
  carrosel,
  enable,
  title,
  section,
  locationOnPage,
}: {
  carrosel: CarroselDataCMS[]
  enable: boolean
  title: string
  section?: string
  locationOnPage?: string
}) {
  const { screenWidth } = useMobile()
  const { pageData } = useGlobalContext()

  if (!enable) {
    return null
  }

  const isCarrosel =
    (screenWidth >= 1024 && carrosel.length >= 5) ||
    (screenWidth < 1024 && carrosel.length >= 3)

  const sendPromoFeatureViewedEvent = (
    item: CarroselDataCMS,
    index?: number
  ) => {
    if (!locationOnPage || !section) {
      return
    }

    const eventData = {
      ...getStandardObject(pageData),
      ...getFeatureObject({
        section,
        locationOnPage,
        name: item?.carroselContent?.title ?? 'N/A',
        index,
      }),
    }

    dispatchAmplitudeEvent({ eventName: 'Promo Feature Viewed', eventData })
  }

  return (
    <section className="section-Infobanner">
      {isCarrosel ? (
        <InfoBannerCarrosel
          carrosel={carrosel}
          locationOnPage={locationOnPage}
          section={section}
          title={title}
          sendPromoFeatureViewedEvent={sendPromoFeatureViewedEvent}
        />
      ) : (
        <section className="container-infobanner">
          {carrosel.map((item: CarroselDataCMS, index: number) => {
            return item?.carroselContent?.enable ? (
              <InView
                as="div"
                threshold={0.7}
                onChange={(inView) => {
                  if (inView) {
                    sendPromoFeatureViewedEvent(item, index)
                  }
                }}
                triggerOnce
              >
                <InfoBannerItem
                  key={index}
                  infobanner={item}
                  index={index}
                  section={section}
                  locationOnPage={locationOnPage}
                  title={title}
                />
              </InView>
            ) : null
          })}
        </section>
      )}
    </section>
  )
}
